import { Target } from "lucide-react";
import { useT } from "@/lib/i18n";

// Color anchors mirror the AI scoring rubric in letter_ai.py so the visual
// language is honest: green = strong fit, amber = decent gaps, red = weak.
const tone = (score) => {
  if (score >= 75) return "border-emerald-700 bg-emerald-50 text-emerald-800";
  if (score >= 60) return "border-amber-600 bg-amber-50 text-amber-800";
  if (score >= 40) return "border-orange-700 bg-orange-50 text-orange-800";
  return "border-rose-700 bg-rose-50 text-rose-800";
};

export function MatchScoreBadge({ score, size = "sm" }) {
  const { t } = useT();
  if (score === null || score === undefined) {
    return (
      <span
        data-testid="match-score-badge"
        data-score="none"
        className="font-mono text-[0.65rem] uppercase tracking-[0.15em] text-neutral-400"
      >
        —
      </span>
    );
  }
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-[0.7rem]";
  return (
    <span
      data-testid="match-score-badge"
      data-score={score}
      title={t("ltMatchScoreHint")}
      className={`inline-flex items-center gap-1 border ${pad} font-mono uppercase tracking-[0.1em] ${tone(score)}`}
    >
      <Target size={size === "lg" ? 14 : 11} strokeWidth={1.75} />
      {score}%
    </span>
  );
}
